import { FeedbackType } from 'constants/automated-feedback'
import { ConversationActionType } from '@marketplace-web/domain/conversation-action'

export function getFeedbackType(action: ConversationActionType | undefined) {
  if (!action) return FeedbackType.AutoReply

  const actionTypeMap = {
    [ConversationActionType.SupportRequestResolvedAutoReply]: FeedbackType.AutoReply,
    [ConversationActionType.SupportRequestNotResolvedAutoReply]: FeedbackType.AutoReply,
    [ConversationActionType.SupportRequestResolvedChatbot]: FeedbackType.Chatbot,
    [ConversationActionType.SupportRequestNotResolvedChatbot]: FeedbackType.Chatbot,
    [ConversationActionType.ConfirmComplaintResolvedAndLeaveFeedback]: FeedbackType.Agent,
    [ConversationActionType.LeaveFeedbackForAgentSupport]: FeedbackType.Agent,
    [ConversationActionType.RefuseComplaintResolved]: FeedbackType.Agent,
  }

  return actionTypeMap[action]
}
